import { getContentGroups } from "../../services/index";
import { useQuery } from "react-query";

export const useGetContentGroups = () => {
  const { data: contentGroups, isLoading: getContentGroupsIsLoading } =
    useQuery("contentGroups", getContentGroups);
  return { contentGroups, getContentGroupsIsLoading };
};
